module.exports = __webpack_public_path__ + "static/media/HarryPotter.f41c63f3.jpg";